<template>
  <div v-if="item.suggestionCounts && item.suggestionCounts.total > 0">
    <div
      :class="$style.membershipUpdateContainer"
    >
      <div :class="$style.membershipUpdateImgContainer">
        <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" :class="$style.membershipUpdateSvg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#icon_refresh_svg__icon/refresh__clip0)"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.365 11.247l.472.11a.807.807 0 00.978-.638.872.872 0 00-.651-1.015l-2.318-.536a.806.806 0 00-.955.548l-.635 2.011a.873.873 0 00.54 1.079.807.807 0 001.043-.522l.07-.22c.971 1.32 2.275 2.13 3.333 2.502a6.665 6.665 0 005.12-.33c1.873-.937 2.937-2.624 3.354-3.947a.873.873 0 00-.539-1.078.807.807 0 00-1.044.521c-.311.988-1.126 2.275-2.533 2.978a5.041 5.041 0 01-3.853.256c-.743-.261-1.664-.824-2.382-1.719zm6.471-5.218a.872.872 0 01-.65-1.015.807.807 0 01.977-.637l.472.109c-.718-.894-1.639-1.457-2.382-1.719a5.04 5.04 0 00-3.852.256c-1.407.703-2.223 1.99-2.534 2.978a.807.807 0 01-1.044.522.873.873 0 01-.539-1.08c.417-1.322 1.48-3.01 3.354-3.945a6.665 6.665 0 015.12-.33c1.059.371 2.362 1.181 3.333 2.502l.07-.221a.806.806 0 011.044-.522.873.873 0 01.539 1.079l-.635 2.012a.806.806 0 01-.955.547l-2.318-.536z" fill="#006CAC"/></g><defs><clipPath id="icon_refresh_svg__icon/refresh__clip0"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs></svg>
      </div>
      <span
        :class="$style.membershipUpdateLabel"
      >
        Membership updates suggested.
        <div
          :class="$style.reviewButtonWrapper"
        >
          <ButtonLink
            :class="$style.reviewButtonLink"
            text="Review"
            @click.native="showModal"
          />
        </div>
      </span>
      <div />
    </div>
  </div>
</template>
<script>
import {
  ButtonLink,
} from '@jumpcloud/ui-components';
import {
  ItemTypeConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import { mapActions } from 'vuex';
import EventHelper from 'client/GrowthEngineering/EventHelper';

const suggestedSystemUsersCollection = StoreModuleMap[ItemTypeConsts.suggestedSystemUser];

export default {
  name: 'MembershipUpdates',

  components: {
    ButtonLink,
  },

  props: {
    displayModal: {
      type: Function,
      default: () => {},
    },
    item: {
      required: true,
      type: Object,
    },
    review: {
      default: false,
      type: Boolean,
    },
  },

  computed: {
    buttonLinkStyle() {
      const style = {
        fontSize: '1rem',
      };

      return style;
    },
  },

  methods: {
    ...mapActions(suggestedSystemUsersCollection, {
      setUserGroupId: 'setUserGroupId',
    }),

    showModal(event) {
      const { id, name } = this.item;
      this.setUserGroupId(id);
      this.displayModal(id, name, this.review);
      const payload = {
        action: 'Open Membership Suggestions Modal From Groups Aside Panel',
        type: 'Membership Suggestions',
      };
      EventHelper.triggerMembershipSuggestionsLinkClicked(payload);
      event.stopPropagation(); /* this stops propagation to user group aside panel */
    },
  },
};
</script>

<style module>

.membershipUpdateContainer {
  display: inline-flex;
  float: right;
}

.membershipUpdateImgContainer {
  outline: none;
  padding: 0 7px;
}

.membershipUpdateLabel {
  font-size: 1rem;
}

.membershipUpdateSvg {
  outline: none;
}

/*
We need to override the style here because we are not able
to customize font size in button link component. */
.reviewButtonLink span {
  font-size: 1rem;
}

.reviewButtonWrapper {
  float: right;
  margin-left: 0.25rem;
  max-width: 6rem;
}
</style>
